export { Thumbnail } from './Thumbnail'
export type {
  BasePlaceholderProps as BaseThumbnailPlaceholderProps,
  BaseThumbnailProps,
  PlaceholderProps as ThumbnailPlaceholderProps,
  ThumbnailProps,
  ThumbnailRef,
  ThumbnailRoles,
  ThumbnailRoleType,
} from './Thumbnail.types'
export { getThumbnailVariantForFilename } from './Thumbnail.utils'
export {
  DocumentIcon as UNSAFE_ThumbnailDocumentIcon,
  type ThumbnailDocumentIconVariant,
} from './ThumbnailDocumentIcon'
